<template>
  <form method="POST" enctype="multipart/form-data">
    <div class="mt-3 text-md-start text-center d-sm-flex">
      <img
        v-if="tempAvatarSrc || user.img"
        :src="tempAvatarSrc ? tempAvatarSrc : user.img"
        class="preview avatar float-md-left avatar-medium rounded-circle shadow me-md-4"
        style="object-fit: cover"
      />

      <input type="hidden" name="avatar_id" :value="user.avatar_id" />
      <input
        type="file"
        id="avatar"
        name="avatar[]"
        class="d-none"
        ref="fileInput"
        accept="image/*"
        @change="onFileChange"
      />
      <div class="mt-md-4 mt-3 mt-sm-0">
        <label for="avatar">
          <span class="btn btn-primary mt-2">{{ pll["Change Picture"] }}</span>
        </label>
        <!-- <a id="remove_file_avatar" class="btn btn-outline-primary mt-2 ms-2"
          >Delete</a
        > -->
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-6" ref="first_name">
        <profile-input
          :label="pll[`First name`] + `*`"
          :placeholder="pll[`First name`] + ' :'"
          :required="true"
          v-model="user.first_name"
          :modelError="v$.user.first_name.$error"
        />
      </div>
      <div class="col-md-6" ref="last_name">
        <profile-input
          :label="pll[`Last Name`]"
          :placeholder="pll[`Last Name`] + ` :`"
          :required="true"
          v-model="user.last_name"
          :modelError="v$.user.last_name.$error"
        />
      </div>
      <div class="col-md-6" ref="user_email">
        <profile-input
          :label="pll[`Your Email`] + `*`"
          :placeholder="pll[`Your Email`] + ` :`"
          :required="true"
          v-model="user.user_email"
          :modelError="v$.user.user_email.$error"
          :readonly="true"
        />
      </div>
      <div class="col-md-6" ref="phone">
        <profile-input
          :label="pll[`Phone`]"
          :placeholder="pll[`Phone`] + ` :`"
          v-model="user.phone"
          :modelError="v$.user.phone.$error"
        />
      </div>
      <div class="col-md-6" ref="short_info">
        <profile-input
          :label="pll[`Occupation`]"
          :placeholder="pll[`Occupation`] + ` :`"
          v-model="user.short_info"
          :modelError="v$.user.short_info.$error"
        />
      </div>
      <div class="col-md-6" ref="age">
        <profile-input
          :label="pll[`Age`]"
          :placeholder="pll[`Age`] + ` :`"
          v-model="user.age"
          :modelError="v$.user.age.$error"
        />
      </div>
      <div class="col-md-6">
        <profile-select
          :label="pll[`Readiness to leave`]"
          v-model="user.readiness_to_leave"
          :data="user.readiness_to_leave_variants"
        />
      </div>
      <div class="col-md-6">
        <profile-select-slug
          :label="pll[`Desired country`]"
          v-model="user.desired_country"
          :data="user.desired_countries"
        />
      </div>
      <div class="col-md-12 mb-3">
        <div class="form-label">{{ pll[`Driver license`] }}</div>
        <div
          class="form-check-inline"
          v-for="(value, key) in driver_license"
          :key="key"
        >
          <checkbox-multi
            :label="value"
            :value="value"
            v-model="user.user_driver_license"
          />
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <checkbox :label="pll[`Have car`]" :id="have_car" v-model="user.have_car" />
      </div>
    </div>
    <div class="row">
      <profile-lang
        v-if="checkLevelsLang()"
        :languages="languages"
        :user_languages="user.user_languages"
        @sendCanSpeak="handleCanSpeak"
      />
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label for="formFile" class="form-label">{{ pll[`CV`] }}</label>

          <div
            v-if="user.cv.url"
            class="mb-1 d-flex justify-content-between align-items-center"
          >
            <div>
              <a :href="user.cv.url" target="_blank">
                <i data-feather="file-text" class="fea me-1"></i>
                {{ user.cv.name }}
              </a>
            </div>

            <button class="btn btn-danger" @click.prevent="user.cv = ''">
              <i data-feather="minus-circle" class="fea"></i>
            </button>
          </div>
          <input
            v-else
            class="form-control"
            type="file"
            ref="formFile"
            @change="onCVChange"
            accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
        </div>
      </div>
      <!--end col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button class="btn btn-primary" @click.prevent="sendData">
          {{ pll[`Save Changes`] }}
        </button>

        <div v-if="isLoading" class="ajax-loader"></div>

        <transition name="fade">
          <div
            class="alert fw-medium mt-3"
            :class="{
              'bg-soft-success': responce.success,
            }"
            role="alert"
            v-if="responce.success"
          >
            <i class="uil uil-check-circle fs-5 align-middle me-1"></i>
            {{ responce.success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            class="alert fw-medium mt-3"
            :class="{
              'bg-soft-danger': responce.error,
            }"
            role="alert"
            v-if="responce.error"
          >
            <i class="uil uil-exclamation-octagon fs-5 align-middle me-1"></i>
            {{ responce.error }}
          </div>
        </transition>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </form>
</template>
<script>
import responses from "./partials/Responses.vue";
import profileInput from "./partials/Input.vue";
import profileSelect from "./partials/Select.vue";
import selectSlug from "./partials/SelectSlug.vue";
import checkboxMulti from "./partials/CheckboxMulti.vue";
import checkbox from "./partials/Checkbox.vue";
import ProfileLangAlternative from "./partials/ProfileLangAlternative.vue";

import axios from "axios";
import qs from "qs";
import { useVuelidate } from "@vuelidate/core";
// Existing default checks/methods for @vuelidate/validators
//   alpha,
//   alphaNum,
//   and,
//   between,
//   createI18nMessage,
//   decimal,
//   email,
//   helpers,
//   integer,
//   ipAddress,
//   macAddress,
//   maxLength,
//   maxValue,
//   minLength,
//   minValue,
//   not,
//   numeric,
//   or,
//   required,
//   requiredIf,
//   requiredUnless,
//   sameAs,
//   url,
import {
  email,
  integer,
  maxLength,
  maxValue,
  required,
} from "@vuelidate/validators";

const phoneValidator = (value) => {
  if (!value) return true;
  const pattern = /^\+?[0-9.]+$/;
  return pattern.test(value);
};

export default {
  components: {
    "profile-input": profileInput,
    "profile-select": profileSelect,
    "profile-select-slug": selectSlug,
    "checkbox-multi": checkboxMulti,
    checkbox,
    responses,
    "profile-lang": ProfileLangAlternative,
  },

  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  validations() {
    return {
      user: {
        first_name: { required },
        last_name: { required },
        user_email: { required, email },
        phone: { phoneValidator },
        short_info: { maxLength: maxLength(500) },
        age: { integer, maxValue: maxValue(200) },
      },
    };
  },
  data() {
    return {
      user: {
        img: this.user_data.img,
        avatar_id: this.user_data.avatar_id,
        first_name: this.user_data.first_name,
        last_name: this.user_data.last_name,
        user_email: this.user_data.user_email,
        phone: this.user_data.phone,
        short_info: this.user_data.short_info,
        age: this.user_data.age,
        readiness_to_leave: this.user_data.readiness_to_leave,
        readiness_to_leave_variants: this.user_data.readiness_to_leave_variants,
        desired_country: this.user_data.desired_country,
        desired_countries: this.user_data.desired_countries,
        user_languages: this.user_data.user_languages,
        user_driver_license: this.user_data.user_driver_license,
        have_car: Boolean(parseInt(this.user_data.have_car)),
        cv: this.user_data.cv,
      },
      driver_license: this.user_data.driver_license,
      languages: this.user_data.languages,
      nonce: api_settings.nonce,
      responce: false,
      avatarFile: null,
      tempAvatarSrc: null,
      cvFile: null,
      isLoading: false,
    };
  },
  props: {
    user_data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    checkLevelsLang() {
      const res = this.user_data.languages.some((el) => {
        return !el.hasOwnProperty("children");
      });
      return !res;
    },
    handleCanSpeak(canSpeak) {
      this.user.languages = canSpeak;
    },
    uploadAvatar() {
      const formData = new FormData();
      formData.append("avatar[]", this.avatarFile);
      formData.append("action", "update_user_avatar");

      axios
        .post(api_settings.ajax_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async sendData() {
      if (!(await this.v$.$validate())) {
        const firstInvalidField = Object.keys(this.v$.user).find(
          (key) => this.v$.user[key].$error
        );
        if (firstInvalidField) {
          this.$refs[firstInvalidField].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return;
      }

      this.isLoading = true;

      const formData = new FormData();
      formData.append("user", qs.stringify(this.user));
      formData.append("nonce", this.nonce);
      formData.append("cv[]", this.cvFile);
      formData.append("action", "update_user_profile");

      axios
        .post(api_settings.ajax_url, formData)
        .then((response) => {
          console.log(response);
          this.responce = response.data;
          const headerName = document.querySelector("#header_display_name");
          headerName.innerHTML =
            this.user.first_name + " " + this.user.last_name;
          setTimeout(() => {
            this.responce = false;
          }, 5000);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onFileChange(e) {
      this.avatarFile = e.target.files[0];
      this.uploadAvatar();

      let reader = new FileReader();
      reader.readAsDataURL(this.avatarFile);
      reader.onload = () => {
        this.tempAvatarSrc = reader.result;
        const profileAvatarBig = document.querySelector("#profile-avatar-big");
        profileAvatarBig.src = reader.result;
        profileAvatarBig.srcset = reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
    onCVChange(event) {
      const allowedFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      const file = event.target.files[0];
      if (file && !allowedFileTypes.includes(file.type)) {
        alert("Invalid file type. Please select a PDF or Word file.");
        this.clearInputFile();
      } else {
        this.cvFile = file;
      }
    },
    clearInputFile() {
      this.$refs.formFile.value = "";
    },
  },
  mounted() {
    feather.replace();
  },
};
</script>